import backlog from './utils/backlog'

const state = () => ({
  backlog,
  links: {},
})

export default state
